import {
  DASHBOARD_OVERVIEW_FETCHING,
  DASHBOARD_OVERVIEW_FAILED,
  DASHBOARD_OVERVIEW_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case DASHBOARD_OVERVIEW_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case DASHBOARD_OVERVIEW_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case DASHBOARD_OVERVIEW_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}